import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {useDataSourceStore} from "@/store/modules/dataSourceStore";
import {useOpenSubPage} from "@/main-page/gridCellCtlShow/hooks/useOpenSubPage";

export function useMsgDealHooks(){
  const {openSubComPage} = useOpenSubPage();
  const pageModelsStore: any = usePageModelsStore();
  const dataSourceStore: any = useDataSourceStore();
  const {state} = storeToRefs(pageModelsStore);
  const viewModel = new ViewModel({viewPage: {}, pageModelsStore, dataSourceStore, state});
  viewModel.openSubComPage = openSubComPage;

  const openMsgDeal = function (inParams) {
    let pageConfig:any = {};
    pageConfig.btnPosition = "rightTop";
    pageConfig.pageCode = inParams['record']['tableCode'] + 'FlowDeal';
    pageConfig.flowDealType = 'flowDeal';
    pageConfig.moduleCode = inParams['record']['tableCode'] + 'FlowDeal';
    pageConfig.winType = 'user-def-drawer';
    pageConfig.winWidth = '1200';
    pageConfig.winHeight = '500';
    pageConfig.winTitle = inParams['businessType'] || inParams['tableName'] || '' + '审批';
    pageConfig.contentFrom = '';
    inParams.showType = 'flowDeal';
    inParams.logShowFlag = 'true';
    inParams.logShowPos = 'right';
    inParams.logWidth = '360';
    inParams.recordFrom = 'busRecord';
    pageConfig.inParams = inParams;
    pageConfig.contentKey = '';
    viewModel.openSubComPage(pageConfig)
  }

  /**
   * 打开部件抽屉
   * @param inParams
   * @param configs
   */
  const openSubPageDrawer = function (inParams,configs) {
    let pageConfig:any = {};
    pageConfig.btnPosition = "rightTop";
    pageConfig.pageCode = configs['pageCode'];
    pageConfig.moduleCode = configs['moduleCode'];
    pageConfig.winType = 'user-def-drawer';
    pageConfig.winWidth = configs['winWidth']||600;
    pageConfig.winHeight = '500';
    pageConfig.winTitle = configs['pageName'];
    pageConfig.contentFrom = '';
    inParams.logShowFlag = 'true';
    inParams.logShowPos = 'right';
    inParams.logWidth = '360';
    inParams.recordFrom = 'msgRecord';
    pageConfig.inParams = inParams;
    pageConfig.contentKey = '';
    viewModel.openSubComPage(pageConfig)
  }

  return {
    openSubPageDrawer,
    openMsgDeal
  }
}
